import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1.5rem',
    height: 'calc(100vh - 120px)',
    width: '100vw',
    maxWidth: '100%',
    paddingBottom: '1.5rem',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1rem',
    width: '100%',
    maxWidth: 450,
  },

  titleBar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',
    maxWidth: 450,
    '& :first-child': {
      marginBottom: '2rem',
    },
  },
  
  locker: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 150,
    color: Colors.gray,
  },

  title: {
    color: 'black',
    fontSize: '2rem',
    fontWeight: '700',
    marginBottom: '1rem',
    maxWidth: '100vw',
  },

  subtitle: {
    fonSize: "1.6 rem",
    fontWeight: '500',
    marginBottom: '1rem',
    padding: '0 2rem',
  },
}))

export default styles
